import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Pagination from '@mui/material/Pagination';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useDispatch, useSelector } from 'react-redux';
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';
import NavBar from '../../structure/NavBar';
import { NavBarTop } from '../../structure/NavBarTop';
import { useNavigate } from 'react-router-dom';
import NoDataImg from "../../../assets/img/no-data.gif";

const AyrshareManager = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.userData);
  const [profiles, setProfiles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize] = useState(10);
  const [pagerecord, setPagerecord] = useState({
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1,
  });
  const navigate = useNavigate();

  useEffect(() => {
    dispatch({ type: 'common/updateTopHeader', payload: 'Ayrshare Manager' });
  }, [dispatch]);

  useEffect(() => {
    fetchProfiles();
  }, [currentPage]);

  const fetchProfiles = async () => {
    try {
      const url = `${urls.ayrshareProfileList}?pageNumber=${currentPage - 1}&pageSize=${pageSize}&shortingField=createdAt&asc=true`;
      const res = await ApiCaller.get({}, url, userData?.access_token);
      const response = await res.response.json();
      if (response.status === 200 || response.status === '200') {
        const data = response.data || {};
        setProfiles(data.items || []);
        setTotalPages(data.totalPages || 0);
        setPagerecord({
          totalItems: data.totalItems || 0,
          pageNumber: (data.pageNumber || 0) + 1,
          pageSize: data.pageSize || 10,
          totalPages: data.totalPages || 1,
        });
      } else {
        setProfiles([]);
        setTotalPages(0);
      }
    } catch (error) {
      setProfiles([]);
      setTotalPages(0);
      console.error('Error fetching profiles:', error);
    }
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handleViewDetails = (profile) => {
    navigate(`/ayrshare-manager/${profile.userId}`, { state: { activeSocialAccounts: profile.activeSocialAccounts || [] } });
  };

    return (
    <>
      <NavBar />
      <div className="main-content">
        <NavBarTop />
        <div className="header">
          <div className="logo">
            <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8"></div>
          </div>
        </div>
        <Box className="content" sx={{ p: 2 }}>
          <div className="container-fluid mt--7">
            <div className="row">
              <div className="col text-left">
                <div className="card shadow">
                  <div className="card-header border-0">
                    <div className="row align-items-center text-left">
                      <div className="col">
                        <h3 className="mb-0">Ayrshare Manager</h3>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    {profiles && profiles.length > 0 ? (
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            <th scope="col">S/No.</th>
                            <th scope="col">User ID</th>
                            <th scope="col">Email</th>
                            <th scope="col">Title</th>
                            <th scope="col">Username</th>
                            <th scope="col">Mobile</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {profiles.map((profile, i) => {
                            const startIndex = (pagerecord.pageNumber - 1) * pagerecord.pageSize;
                            return (
                              <tr key={profile.userId}>
                                <td>{startIndex + i + 1}</td>
                                <td>{profile.userId}</td>
                                <td>{profile.email}</td>
                                <td>{profile.title}</td>
                                <td>{profile.userName}</td>
                                <td>{profile.userMobile}</td>
                                <td>
                                  <button className="btn btn-sm btn-primary text-white" onClick={() => handleViewDetails(profile)}>
                                    View Details
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    ) : (
                      <div className="text-center">
                        <img width={"25%"} src={NoDataImg} alt="No Data" />
                        <br />
                        <label style={{ fontWeight: 'bold' }}>
                          No Data Found
                        </label>
                      </div>
                    )}
                  </div>
                  {profiles && profiles.length > 0 && (
                    <div className="card-footer py-4">
                      <Box display="flex" justifyContent="right" alignItems='center'>
                        <span>Total record: {pagerecord?.totalItems}</span>
                        <Pagination
                          className="custom-pagination-class"
                          count={pagerecord?.totalPages}
                          page={currentPage}
                          onChange={handlePageChange}
                          color="secondary"
                        />
                      </Box>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Box>
      </div>
    </>
  );
};

export default AyrshareManager;